import React, {useContext} from "react";

import Table from "../common/Table";
import RowPhoto from "../common/TdImg";
import Option from "../common/RowOption";
import { Link } from "react-router-dom";

const TeachersList = ({ data }) => {

  const renderLink = (e) => {
    return (
      <Link
        to={`/mis/teachers/${e.teacher_id}/profile/salary?teacherName=${e.teacher_name}`}
      >
        {e.teacher_name}
      </Link>
    );
  };


  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "teacher_photo",
      label: "عکس",
      content: ({ teacher_photo }) => <RowPhoto src={teacher_photo} />,
    },
    { path: "aria_id", label: "کد استاد" },
    {
      path: "teacher_name",
      label: "اسم",
      content: (e) => renderLink(e),
    },
    { path: "teacher_phone", label: "شماره تماس" },
    { path: "teacher_email", label: "ایمیل" },
    { path: "faculty", label: "پوهنحی" },
    { path: "user_status", label: "وضعیت", content: ({ user_status }) => user_status ? "برحال" : "اسبق" },
    {
      path: "option",
      content: (e) => <Option Edit={{form: "teacher-form",edit: e}} Delete={{id: e.teacher_id, route: 'teachers'}} />
    },
  ];

  return <Table data={data} columns={columns} />;
};

export default TeachersList;
